import React, { ReactNode, useCallback } from 'react';
import cn from 'classnames';
import styles from './Input.module.scss';

export type InputProps = {
  value?: string;
  onChange?: (_value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  prefix?: ReactNode;
  error?: string;
  onFocus?: () => void;
};

const Input: React.FC<InputProps> = ({
  value,
  onChange,
  placeholder,
  className,
  disabled,
  prefix,
  error,
  onFocus,
}) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.value);
    },
    [onChange]
  );

  const handleFocus = useCallback(() => {
    onFocus?.();
  }, [onFocus]);

  return (
    <div className={cn(styles.container, className)}>
      {placeholder && <div className={styles.placeholder}>{placeholder}</div>}
      <div
        className={cn(styles.inputContainer, {
          [styles['inputContainer--disabled']]: disabled,
          [styles['inputContainer--error']]: !!error,
        })}
      >
        {prefix && (
          <div className={styles.inputContainer__prefix}>{prefix}</div>
        )}
        <input
          className={styles.inputContainer__input}
          type="text"
          value={value ?? ''}
          onChange={handleChange}
          onFocus={handleFocus}
          disabled={disabled}
        />
      </div>
      <div className={styles.error}>{error || ' '}</div>
    </div>
  );
};

export default Input;
